
import React, { useState, useEffect, useRef } from "react";
import PrivateRoute from "shared/PrivateRoute/PrivateRoute.js";
import MobileSide from "shared/MobileSide/MobileSidebar.jsx";
import HeaderNew1 from "shared/HeaderNew1/HeaderNew1.jsx";
import RequestAppointmentComponent from "components/HomeClientNew/RequestAppointment/RequestAppointmentComponent";
import { useSelector, useDispatch } from "react-redux";
import { setSidebar } from "../../../slices/slices";
import Footer from 'components/Footer/Footer';
import { useGetMainQuery } from "services/clientApi";

const RequestAppointment = () => {
    const dispatch = useDispatch();
    const showSidebar = useSelector((state) => state.common.showSidebar); // right sidebar global state
    const [openMobileSide, setOpenMobileSide] = useState(false);
    const [isMobile, setIsMobile] = useState("");
    const [hasOverflowY, setHasOverflowY] = useState(false);
    const screenWidth = useSelector((state) => state?.common?.screenWidth);
    const { data: main, isLoading: mainLoading, isError: mainError, refetch } = useGetMainQuery();

    useEffect(() => {
        refetch();
        const interval = setInterval(() => {
            refetch();
        }, 60000);

        return () => clearInterval(interval);
    }, [refetch]);

    const contentRef = useRef(null);

    useEffect(() => {
        if (
            screenWidth === "lg" ||
            screenWidth === "md" ||
            screenWidth === "sm" ||
            screenWidth === "xs"
        ) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [screenWidth]);

    useEffect(() => {
        const checkOverflow = () => {
            const el = contentRef.current;
            if (el) {
                const hasOverflow = el.scrollHeight > el.clientHeight;
                setHasOverflowY(hasOverflow);
            }
        };

        const timeout = setTimeout(checkOverflow, 100);

        window.addEventListener("resize", checkOverflow);
        return () => {
            clearTimeout(timeout);
            window.removeEventListener("resize", checkOverflow);
        };
    }, [main, showSidebar]);

    const openSideBar = () => {
        setOpenMobileSide(!openMobileSide);
    };

    return (
        <div className="d-flex" style={{ height: "100vh", overflow: "hidden" }}>
            {isMobile && openMobileSide && (
                <MobileSide openSideBar={openSideBar} />
            )}

            <div
                ref={contentRef}
                className="w-100 bg-light"
                style={{
                    overflowY: "auto",
                    height: "100vh",
                    marginTop: !isMobile ? '72px' : ''
                }}
            >
                <HeaderNew1
                    isMobile={isMobile}
                    main={main}
                    showSidebar={showSidebar}
                    setShowSidebar={(val) => dispatch(setSidebar(val))}
                    hasOverflowY={hasOverflowY}
                />
                <RequestAppointmentComponent
                    isMobile={isMobile}
                    mainProps={{ main, mainLoading, mainError }}
                    showSidebar={showSidebar}
                />
                <div
                    ref={contentRef}
                    className="w-100 bg-light mt-3"
                    style={{
                        overflowY: "auto",
                        minHeight: "10vh",
                    }}
                >
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default PrivateRoute(RequestAppointment);